var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.782,
    height: 38.787,
    viewBox: "0 0 38.782 38.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.012,
    y1: 1.024,
    x2: 1.043,
    y2: -0.031,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_code",
    "data-name": "qr code",
    transform: "translate(-2.629 -2.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M3851.9,17065.725a2.879,2.879,0,0,1-2.878-2.879v-12.387a2.878,2.878,0,0,1,2.878-2.873h12.386a2.877,2.877,0,0,1,2.874,2.873v12.387a2.878,2.878,0,0,1-2.874,2.879Zm.12-3h12.142v-12.139h-12.142Zm30.846,2.877a.7.7,0,0,1-.69-.689v-4.129a.7.7,0,0,1,.69-.689h4.129a.694.694,0,0,1,.689.689v4.129a.694.694,0,0,1-.689.689Zm-12.386,0a.7.7,0,0,1-.689-.689v-2.754a.694.694,0,0,1,.689-.686h2.75a.694.694,0,0,1,.689.686v2.754a.694.694,0,0,1-.689.689Zm5.5-5.508a.691.691,0,0,1-.689-.686v-5.508a.694.694,0,0,1,.689-.686h5.508a.693.693,0,0,1,.685.686v5.508a.69.69,0,0,1-.685.686Zm-20.644,0a.691.691,0,0,1-.689-.686v-5.508a.694.694,0,0,1,.689-.686h5.5a.694.694,0,0,1,.689.686v5.508a.691.691,0,0,1-.689.686Zm15.14-6.879a.7.7,0,0,1-.689-.689v-4.129a.7.7,0,0,1,.689-.689h4.129a.691.691,0,0,1,.685.689v4.129a.691.691,0,0,1-.685.689Zm13.761-1.379a.694.694,0,0,1-.69-.686v-2.754a.7.7,0,0,1,.69-.689h2.754a.694.694,0,0,1,.689.689v2.754a.694.694,0,0,1-.689.686Zm-11.7-6.758a2.878,2.878,0,0,1-2.878-2.873v-12.387a2.882,2.882,0,0,1,2.878-2.879h12.386a2.88,2.88,0,0,1,2.874,2.879v12.387a2.877,2.877,0,0,1-2.874,2.873Zm.124-3H3884.8v-12.139h-12.138Zm-20.768,3a2.878,2.878,0,0,1-2.878-2.873v-12.387a2.881,2.881,0,0,1,2.878-2.879h12.386a2.881,2.881,0,0,1,2.874,2.879v12.387a2.877,2.877,0,0,1-2.874,2.873Zm.12-3h12.142v-12.139h-12.142Zm23.963-2.629a.691.691,0,0,1-.689-.686v-5.508a.694.694,0,0,1,.689-.686h5.508a.693.693,0,0,1,.685.686v5.508a.69.69,0,0,1-.685.686Zm-20.644,0a.691.691,0,0,1-.689-.686v-5.508a.694.694,0,0,1,.689-.686h5.5a.694.694,0,0,1,.689.686v5.508a.691.691,0,0,1-.689.686Z",
    transform: "translate(-3846.392 -17024.311)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticketIcon.3d879e67d262132524f6dcfccb47add6.svg";
export { ForwardRef as ReactComponent };